import { rgba } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const CardInfo = styled.div`
  border-top: 1px solid ${({ theme }) => theme.ds.colors.neutral200};
  padding-top: 24px;

  /* .item-wrapper {
    font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
    color: ${({ theme }) => theme.ds.colors.neutral500};
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
  }

  .item-result {
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    color: ${({ theme }) => theme.ds.colors.neutral900};
    font-weight: ${({ theme }) => theme.ds.typography.weight.normal};
  }

  .calendar-container {
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
      width: 16px;
    }
  } */
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > .btn-edit {
    width: 34px;
    height: 34px !important;
    border-radius: 50%;
    background-color: ${({ theme }) => rgba(theme.ds.colors.primary600, 0.1)};

    &:hover {
      background-color: ${({ theme }) => rgba(theme.ds.colors.primary600, 0.2)};
    }
  }
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`

export const BoxInfo = styled.div`
  /* &:not(:first-of-type) {
    margin-top: 8px;
  } */

  /* .label {
    font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
    color: ${({ theme }) => theme.ds.colors.neutral800};
    font-weight: ${({ theme }) => theme.ds.typography.weight.normal};
    line-height: 18px;
  }

  .text {
    margin-top: 4px;
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    color: ${({ theme }) => theme.ds.colors.primary600};
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
    line-height: 21px;

    &.-small {
      font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
      color: ${({ theme }) => theme.ds.colors.neutral500};
      font-weight: ${({ theme }) => theme.ds.typography.weight.normal};
      line-height: 16px;
    }

    &.-large {
      font-size: ${({ theme }) => theme.ds.typography.size.small};
      font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
      line-height: 24px;
      margin-bottom: 8px;
    }
  }

  .list {
    list-style: none;

    .item {
      display: flex;
      align-items: center;
      gap: 4px;
      margin: 8px 0 0;
      padding: 0;

      &:not(:first-of-type) {
        margin-top: 4px;
      }
    }
  } */
`
